"use client";

import { c as _c } from "react/compiler-runtime";
import { Check, Globe, Lock, Sparkles } from "lucide-react";
interface VelyqIn30sProps {
  locale: string;
}
export function VelyqIn30s(t0) {
  const $ = _c(35);
  const {
    locale
  } = t0;
  const isFr = locale === "fr";
  let t1;
  let t10;
  let t11;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== isFr) {
    const content = isFr ? {
      eyebrow: "VELYQ EN 30 SECONDES",
      q1: "Qu'est-ce que Velyq ?",
      a1: "Velyq est un \xE9cosyst\xE8me carri\xE8re tout-en-un qui r\xE9unit 8 outils connect\xE9s \u2014 CV, analyse ATS, entretiens IA (classique + vocal), lettres de motivation, LinkedIn, tracker de candidatures, extension Chrome \u2014 pour chercher un job en France et en Europe.",
      q2: "C'est gratuit ?",
      a2: "Oui \u2014 plan gratuit avec quotas (3 entretiens, 1 analyse ATS, 1 lettre par mois). Premium \xE0 9,99 \u20AC/mois d\xE9bloque l'usage illimit\xE9 et les modes sectoriels (tech, finance, consulting).",
      q3: "En quoi c'est diff\xE9rent de Huntr, Simplify ou LinkedIn Premium ?",
      a3: "Huntr et Simplify sont des trackers de candidatures seuls. LinkedIn Premium est un filtre de recherche. Velyq est la seule plateforme FR qui combine CV builder, analyse ATS, simulation d'entretien vocale et tracker dans un seul produit \u2014 avec un plan gratuit utilisable.",
      q4: "\xC7a marche en fran\xE7ais ?",
      a4: "Oui \u2014 100 % FR natif (UI, feedback, coach IA, CV templates). EN dispo. Donn\xE9es h\xE9berg\xE9es en Europe (GCP europe-west1), RGPD.",
      items: [{
        icon: Sparkles,
        label: "8 outils connect\xE9s"
      }, {
        icon: Check,
        label: "Gratuit pour commencer"
      }, {
        icon: Globe,
        label: "FR + EN, UE hosted"
      }, {
        icon: Lock,
        label: "RGPD, serveurs europe-west1"
      }]
    } : {
      eyebrow: "VELYQ IN 30 SECONDS",
      q1: "What is Velyq?",
      a1: "Velyq is an all-in-one career ecosystem combining 8 connected tools \u2014 CV builder, ATS analyzer, AI interviews (classic + voice), cover letters, LinkedIn rewrite, application tracker, Chrome extension \u2014 for job seekers in France and Europe.",
      q2: "Is it free?",
      a2: "Yes \u2014 free plan with monthly quotas (3 interviews, 1 ATS analysis, 1 cover letter). Premium at \u20AC9.99/mo unlocks unlimited usage and sector modes (tech, finance, consulting).",
      q3: "How is it different from Huntr, Simplify or LinkedIn Premium?",
      a3: "Huntr and Simplify are trackers only. LinkedIn Premium is a search filter. Velyq is the only French platform combining CV builder, ATS analysis, voice interview simulation and tracker in one product \u2014 with a usable free plan.",
      q4: "Does it work in English?",
      a4: "Yes \u2014 full EN support (UI, feedback, AI coach, CV templates). French is the native locale. Data hosted in Europe (GCP europe-west1), GDPR-compliant.",
      items: [{
        icon: Sparkles,
        label: "8 connected tools"
      }, {
        icon: Check,
        label: "Free to start"
      }, {
        icon: Globe,
        label: "FR + EN, EU hosted"
      }, {
        icon: Lock,
        label: "GDPR, europe-west1"
      }]
    };
    t9 = "velyq-en-30s";
    t10 = "velyq-in-30s-heading";
    t11 = "border-t border-border/30 bg-gradient-to-b from-background via-card/20 to-background py-16 sm:py-20";
    t8 = "container mx-auto px-4";
    t3 = "mx-auto max-w-3xl";
    let t12;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = <Sparkles className="h-3.5 w-3.5" />;
      $[12] = t12;
    } else {
      t12 = $[12];
    }
    t4 = <span className="inline-flex items-center gap-1.5 rounded-full border border-primary/30 bg-primary/10 px-3 py-1 text-[11px] font-semibold tracking-wider text-primary">{t12}{content.eyebrow}</span>;
    t5 = <h2 id="velyq-in-30s-heading" className="mt-4 font-display text-2xl font-bold tracking-tight sm:text-3xl">{content.q1}</h2>;
    t6 = <p className="mt-3 text-base text-muted-foreground leading-relaxed">{content.a1}</p>;
    const t13 = <div><dt className="font-semibold text-foreground">{content.q2}</dt><dd className="mt-1.5 text-sm text-muted-foreground leading-relaxed">{content.a2}</dd></div>;
    const t14 = <div><dt className="font-semibold text-foreground">{content.q3}</dt><dd className="mt-1.5 text-sm text-muted-foreground leading-relaxed">{content.a3}</dd></div>;
    const t15 = <div><dt className="font-semibold text-foreground">{content.q4}</dt><dd className="mt-1.5 text-sm text-muted-foreground leading-relaxed">{content.a4}</dd></div>;
    if ($[13] !== t13 || $[14] !== t14 || $[15] !== t15) {
      t7 = <dl className="mt-8 space-y-5">{t13}{t14}{t15}</dl>;
      $[13] = t13;
      $[14] = t14;
      $[15] = t15;
      $[16] = t7;
    } else {
      t7 = $[16];
    }
    t1 = "mt-8 grid grid-cols-2 gap-3 sm:grid-cols-4";
    t2 = content.items.map(_temp);
    $[0] = isFr;
    $[1] = t1;
    $[2] = t10;
    $[3] = t11;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
  } else {
    t1 = $[1];
    t10 = $[2];
    t11 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
    t7 = $[9];
    t8 = $[10];
    t9 = $[11];
  }
  let t12;
  if ($[17] !== t1 || $[18] !== t2) {
    t12 = <ul className={t1}>{t2}</ul>;
    $[17] = t1;
    $[18] = t2;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t12 || $[21] !== t3 || $[22] !== t4 || $[23] !== t5 || $[24] !== t6 || $[25] !== t7) {
    t13 = <div className={t3}>{t4}{t5}{t6}{t7}{t12}</div>;
    $[20] = t12;
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13 || $[28] !== t8) {
    t14 = <div className={t8}>{t13}</div>;
    $[27] = t13;
    $[28] = t8;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t10 || $[31] !== t11 || $[32] !== t14 || $[33] !== t9) {
    t15 = <section id={t9} aria-labelledby={t10} className={t11}>{t14}</section>;
    $[30] = t10;
    $[31] = t11;
    $[32] = t14;
    $[33] = t9;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  return t15;
}
function _temp(t0) {
  const {
    icon: Icon,
    label
  } = t0;
  return <li key={label} className="flex items-center gap-2 rounded-lg border bg-card/40 px-3 py-2 text-xs text-muted-foreground"><Icon className="h-3.5 w-3.5 text-primary shrink-0" /><span className="leading-tight">{label}</span></li>;
}